module.exports = __webpack_public_path__ + "img/threads.d4673110.svg";